import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationID from './locales/id.json';

import { detectBrowserLanguage } from '@/lib/utils';

const debug = process.env.NODE_ENV !== 'production';

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

const init = async () => {
  const defaultLanguage = 'en';

  await i18next.use(initReactI18next).init({
    resources,
    fallbackLng: defaultLanguage,
    lng: detectBrowserLanguage(),
    debug,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });
};

let initPromise: Promise<void> | null = null;
let isInitialized = false;

export const ensureI18nInitialized = (): Promise<void> => {
  if (isInitialized) {
    return Promise.resolve();
  }

  if (!initPromise) {
    initPromise = init()
      .then(() => {
        isInitialized = true;
      })
      .catch((error) => {
        initPromise = null;
        throw error;
      });
  }
  return initPromise;
};

export const changeLanguage = (language: string) => {
  return i18next.changeLanguage(language);
};
export const getCurrentLanguage = () => {
  return i18next.language;
};

export const isI18nInitialized = () => isInitialized;
export { i18next };
